module.exports = __webpack_public_path__ + "img/teslaBanner.ad46a5b3.png";